import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import Nav from "@/components/nav/navBar.vue";

var CountDown =
/*#__PURE__*/
function (_Vue) {
  _inherits(CountDown, _Vue);

  function CountDown() {
    _classCallCheck(this, CountDown);

    return _possibleConstructorReturn(this, _getPrototypeOf(CountDown).apply(this, arguments));
  }

  _createClass(CountDown, [{
    key: "timeStr",
    get: function get() {
      if (this.countTime) {
        var min = Math.floor(this.countTime / 60);
        min = min < 10 ? '0' + min : min;
        var sec = this.countTime % 60;
        sec = sec < 10 ? '0' + sec : sec;
        return min + ":" + sec;
      } else {
        return '00:00';
      }
    }
  }]);

  return CountDown;
}(Vue);

tslib_1.__decorate([Prop({
  default: 0
})], CountDown.prototype, "countTime", void 0);

CountDown = tslib_1.__decorate([Component({
  components: {
    Nav: Nav
  }
})], CountDown);
export default CountDown;